import styled from "styled-components"

const StyledTitleRight = styled.div`
  text-align: right;
`

export const Styled = {
  StyledTitleRight,
}
